import { render, staticRenderFns } from "./registerThree.vue?vue&type=template&id=7cef12e4&scoped=true&"
import script from "./registerThree.vue?vue&type=script&lang=js&"
export * from "./registerThree.vue?vue&type=script&lang=js&"
import style0 from "./registerThree.vue?vue&type=style&index=0&id=7cef12e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef12e4",
  null
  
)

export default component.exports